import React from 'react'
import { connect } from 'react-redux'
import { reduxForm, getFormValues } from 'redux-form'
import { Breadcrumb, Button, Confirm } from 'semantic-ui-react'
import { MainBodyContent } from 'components'
import { scrollToFirstValidateFailElement } from 'core/utilities'
import { bgCompanyLimitBankPath } from 'routes'
import { BottomActionsContainer } from './styled'
import { createBGLimitOfBank, getBGLBPermission, getBGLBUsage } from 'ducks/bgLimitOfBank'
import { validateField } from '../helper'
import { getCompanies } from 'ducks/options'
import { getBankOwners } from 'ducks/bankGuarantee'
import InformationComponent from '../Shareds/Information'

const CreateBGLimitOfBank = (props) => {

  const { 
    valueForm, 
    permission
  } = props

  const [showConfirm, setShowConfirm] = React.useState(false)

  React.useEffect(() => {
    props.getBGLBPermission()
    props.getCompanies()
    props.getBankOwners()
  }, [])

  React.useEffect(()=>{
    if(!permission){
      props.history.replace(bgCompanyLimitBankPath)
    }
  },[permission])

  // const onSubmitForm = () => {
  //   const sleep = ms => new Promise(resolve => setTimeout(resolve, ms)) 
  //   return sleep(100)
  //   .then(() => {
  //     setShowConfirm(true)
  //   })
  // } 

  const confirmSubmit = () =>{
    setShowConfirm(false)
    props.createBGLimitOfBank(valueForm, props.history)
  }

  const getUsage = (companyCode,bankName) =>{
    if(companyCode&&bankName){
      props.getBGLBUsage(
        companyCode, 
        bankName, 
        (value) => {
          props.change('usage', value)
        }
      )
    }
  }
  
  return (
    <MainBodyContent 
      headerTitle='Limit of Bank - Create'
      breadcrumbs={
        <Breadcrumb 
          icon='right angle' 
          sections={
            [
              { key: 'LB', content: 'Limit of Bank', link: true, onClick: () => props.history.push(bgCompanyLimitBankPath) },
              { key: 'LBCreate', content: 'Create', active: true }
            ]
          }
        />
      }
    >
      <InformationComponent 
        onChangeCompany={(val)=>getUsage(val,valueForm.bankName)}
        onChangeBank={(val)=>getUsage(valueForm.companyCode,val)}
        isCreate
      />
      <div style={{height:'1rem'}}/>
      <form onSubmit={props.handleSubmit(()=>setShowConfirm(true))}>
        <BottomActionsContainer>
          <Button 
            content='Save' 
            color='blue' 
            icon='save' 
            labelPosition='right'
            style={{ marginRight: '5px' }}
          />
        </BottomActionsContainer>
      </form>
      <Confirm
        size='tiny'
        open={showConfirm}
        onCancel={() => setShowConfirm(false)}
        onConfirm={() => confirmSubmit()}
      />
    </MainBodyContent>
  )
}

const mapStateToProps = (state, props) => {
  const valueForm = getFormValues('formBGLimitOfBank')(state) || {}

  return ({
    valueForm,
    permission: state.bgLimitOfBank.permission,
    initialValues: {
    },
  })
}

const mapDispatchToProps = {
  createBGLimitOfBank,
  getCompanies,
  getBankOwners,
  getBGLBPermission,
  getBGLBUsage
}

const validate = (values) => {
  let errors = validateField(values)
  return errors
}

const ContForm = reduxForm({
  form: 'formBGLimitOfBank',
  enableReinitialize: true,
  onSubmitFail: scrollToFirstValidateFailElement,
  validate,
})(CreateBGLimitOfBank)

export default connect(mapStateToProps, mapDispatchToProps)(ContForm)
